import * as React from "react"
import type { SVGProps } from "react"
const SvgUnorderedList = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M10 19.14a1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.72q0-.42.29-.71a1 1 0 0 1 .71-.29h10q.42 0 .71.29.3.3.29.71c-.01.41-.1.52-.29.72a1 1 0 0 1-.71.28zm0-6a1 1 0 0 1-.71-.28 1 1 0 0 1-.29-.72q0-.42.29-.71a1 1 0 0 1 .71-.29h10q.42 0 .71.29.3.3.29.71c-.01.41-.1.52-.29.72a1 1 0 0 1-.71.28zm0-6a1 1 0 0 1-.71-.28A1 1 0 0 1 9 6.14q0-.42.29-.71a1 1 0 0 1 .71-.29h10q.42 0 .71.29.3.3.29.71c-.01.41-.1.52-.29.72a1 1 0 0 1-.71.28zm-5 13q-.82 0-1.41-.58A2 2 0 0 1 3 18.13q0-.83.59-1.41A2 2 0 0 1 5 16.14q.82 0 1.41.59.6.6.59 1.41c-.01.81-.2 1.02-.59 1.42a2 2 0 0 1-1.41.58m0-6q-.82 0-1.41-.58A2 2 0 0 1 3 12.14q0-.83.59-1.41A2 2 0 0 1 5 10.14q.82 0 1.41.59.6.6.59 1.41c-.01.81-.2 1.02-.59 1.42a2 2 0 0 1-1.41.58m0-6q-.82 0-1.41-.58A2 2 0 0 1 3 6.14q0-.83.59-1.41A2 2 0 0 1 5 4.14q.82 0 1.41.59.6.6.59 1.41c-.01.81-.2 1.02-.59 1.42A2 2 0 0 1 5 8.14" />
  </svg>
)
export default SvgUnorderedList
